<template>
  <div class="parallelBranch">
    <List v-if="modelId===1" @bindDevice="bindDevice" :params="listParams"></List>
    <Bind v-if="modelId===2" @closeBind="closeBind" :row="row"></Bind>
  </div>
</template>

<script>
  import List from './list'
  import Bind from './bind'
  export default {
    components: {
      List,
      Bind
    },
    data() {
      return {
        modelId:1,
        listParams:'',
        row:''
      };
    },
    methods: {
      //初始数据
      init() {

      },
      //绑定设备
      bindDevice(data){
        this.modelId = 2
        this.row = data.row
        this.listParams = data.params
      },
      //关闭绑定
      closeBind(){
        this.modelId = 1
        //刷新列表
      }
    },
    created() {
      this.init();
    }
  };
</script>

<style lang="scss">
  .parallelBranch {}
</style>



// WEBPACK FOOTER //
// src/views/boss/parallelBranch/index.vue